<template>
  <div>
    <div v-if="!items || !items.length" class="pl-sm-10">{{ $t('no_data') }}</div>

    <v-treeview v-else :items="items" item-children="child_pages" item-key="id" open-all>
      <template v-slot:label="{ item }">
        <div class="d-flex align-center" style="white-space: pre-wrap;">
          <span v-if="item.title">{{ item.title }}</span>
          <span class="grey--text" v-else>{{ $t('no_title') }}</span>
          <v-btn icon class="ml-4" @click="$emit('edit', item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon class="" @click="$emit('delete', item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  name: 'PagesTreeView',

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped></style>
